import { useEffect, useReducer } from "react";
import { Text, Alert, AccessCard } from "@artprov/design-system";
import { ContainerCard } from "../common/components/ContainerCard";
import { CardLinks } from "../common/components/CardLinks";
import links from "../common/data/links.json";
import { Loading } from "../common/components/Loading";
import { mapUrlByBranch } from "../common/config/utils/enviroment";
import PropTypes from "prop-types";
import { ContainerCardGrid } from "../common/components/ContainerCardGrid";
import { getAplicacionesBranding } from "../common/services/aplicaciones";

const initialFetchState = {
  aplicacionesBackend: [],
  loading: true,
};

function fetchReducer(state, action) {
  switch (action.type) {
    case "start":
      return { ...state, loading: true };
    case "success":
      return { aplicacionesBackend: action.payload, loading: false };
    case "error":
      return { aplicacionesBackend: [], loading: false };
    default:
      return state;
  }
}

export const Portal = ({ user, show }) => {
  const [state, dispatch] = useReducer(fetchReducer, initialFetchState);
  const { aplicacionesBackend, loading } = state;

  useEffect(() => {
    let mounted = true;

    const obtenerAplicaciones = async () => {
      try {
        dispatch({ type: "start" });
        const { data } = await getAplicacionesBranding();
        if (mounted) {
          dispatch({ type: "success", payload: Array.isArray(data) ? data : [] });
        }
      } catch {
        if (mounted) {
          dispatch({ type: "error" });
        }
      }
    };

    obtenerAplicaciones();

    return () => {
      mounted = false;
    };
  }, []);

  const aplicacionesUsuario = user?.realm_access?.roles?.filter((role) =>
    role.startsWith("acceso-")
  ) ?? [];

  const sistemas = (aplicacionesBackend ?? []).reduce((acc, sistema) => {
    if (!aplicacionesUsuario.includes(sistema.ROL)) {
      return acc;
    }

    acc.push({
      url: mapUrlByBranch(import.meta.env.VITE_ENTORNO, sistema.URL),
      rol: sistema.ROL,
      icono: sistema.ICONO,
      titulo: sistema.TITULO,
      subtitulo: sistema.ABREVIATURA,
      color: sistema.COLOR,
    });

    return acc;
  }, []);

  return (
    show && (
      <div className="mx-24">
        <div className="w-full flex flex-col justify-center items-center mt-[84px]">
          <Text variant="subtitle1" className="text-tertiary-30">
            ¡Hola {user?.name}!
          </Text>
          <Text variant="h5" className="text-primary-20">
            Accedé a tus productos y herramientas desde un único lugar
          </Text>
        </div>
        <div className="py-8">
          <Alert
            buttonText=""
            description="Si estás realizando teletrabajo, es necesario que te conectes a la VPN para poder gestionar a través de los aplicativos."
            variant="warning"
            icon="info"
            title=""
            interactive={false}
            iconStyle="text-warning-10"
            containerStyle="max-w-full"
          />
        </div>
        <Loading show={loading} />
        <ContainerCard>
          {sistemas.map((sistema) => (
            <AccessCard
              key={sistema.rol}
              url={sistema.url}
              color={sistema.color}
              title={sistema.titulo}
              subtitle={sistema.subtitulo}
              icon={sistema.icono}
            />
          ))}
        </ContainerCard>

        {sistemas?.length > 0 && <hr className="mt-7 mb-7 w-full border-tertiary-80" />}

        <ContainerCardGrid>
          {links.map((a) => (
            <CardLinks key={a.titulo} aplicativo={a} />
          ))}
        </ContainerCardGrid>
      </div>
    )
  );
};

Portal.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string,
    realm_access: PropTypes.shape({
      roles: PropTypes.arrayOf(PropTypes.string),
    }),
  }),
  show: PropTypes.bool,
};
